import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Humidor — desktop humidor with lid seam and hygrometer. */
export function HumidorIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <rect x="3" y="6.5" width="18" height="12" rx="1.5" />
      <path d="M3 10.5h18" />
      <circle cx="12" cy="14.5" r="2" />
      <path d="M10 4.5h4" />
    </PortalIcon>
  );
}
